export default "__VITE_ASSET__DvQ8QH6H__"